
      import buffer from 'https://cdn.jsdelivr.net/npm/buffer@6.0.3/+esm'
      window.Buffer = buffer.Buffer
    